module.exports = __webpack_public_path__ + "img/c07_unittechskirmisherchampion_Normal_ua.bc90194d.webp";